import { Box, Image } from '@chakra-ui/react';
import _, { lowerCase } from 'lodash';

import { COMMON_WEB_PATH } from '../../constant';

const GameTag = ({ game_tags_props = [] } = {}) => {
  const splitTag = (tag) => {
    const [tagName] = _.split(tag, '_');
    return { tagType: '', tagName: lowerCase(tagName) };
  };
  return (
    <Box
      position={`absolute`}
      top={'0.2em'}
      left={'-0.3em'}
      zIndex={`10`}
      display="flex"
      gap="5px"
      w={{
        base: '3.5em',
        md: '4.5em'
      }}
    >
      {game_tags_props?.map((tag) => {
        const { tagName } = splitTag(tag);

        return (
          <Image
            src={`${COMMON_WEB_PATH}/blue-layout/gameType/img_${tagName}_tag.png`}
          />
        );
      })}
    </Box>
  );
};

export default GameTag;
